<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <img :src="logo" style="max-width:50%;" class="mx-auto"/>
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Crea tu Cuenta de Usuario</h4>
                  <p class="mb-0">Completa tus datos para registrarte</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="registerUser">

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          type="text" placeholder="Nombre Completo"
                          name="fullName" class="form-control"
                          v-model="user.full_name" required/>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          type="text" placeholder="Nombre de Usuario (único)"
                          name="username" class="form-control"
                          v-model="user.username" required/>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          type="email" placeholder="Correo Electrónico"
                          name="email" class="form-control"
                          v-model="user.email" required/>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          type="text" placeholder="Documento de Identificación (Cédula/DNI)"
                          name="document" class="form-control"
                          v-model="user.document" required/>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          :type="passwordFieldType" placeholder="Contraseña"
                          name="password" class="form-control"
                          v-model="user.password" required
                          style="border-right: none;"
                        />
                        <span
                          class="input-group-text password-toggle"
                          @click="togglePasswordVisibility('password')"
                        >
                          <i :class="passwordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                        </span>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          :type="confirmPasswordFieldType" placeholder="Confirmar Contraseña"
                          name="confirmPassword" class="form-control"
                          v-model="confirmPassword" required
                          style="border-right: none;"
                        />
                        <span
                          class="input-group-text password-toggle"
                          @click="togglePasswordVisibility('confirm')"
                        >
                          <i :class="confirmPasswordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                        </span>
                      </div>
                    </div>

                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4"
                        color="primary"
                        fullWidth
                        size="lg"
                        :disabled="registrationLoading"
                      >
                        <i v-if="registrationLoading" class="fas fa-spinner fa-spin me-2"></i>
                        {{ registrationLoading ? 'Registrando...' : 'Registrarse' }}
                      </argon-button>
                    </div>
                  </form>
                </div>

                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿Ya tienes una cuenta?
                    <router-link :to="{ name: 'Signin' }" class="text-primary font-weight-bold">
                      Iniciar Sesión
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <footer class="footer pb-3">
              <div class="container">
                <div class="row align-items-center justify-content-lg-between">
                  <div class="col-lg-6 mb-lg-0 mb-4">
                    <div class="copyright text-center text-sm text-muted text-lg-start">
                      © {{ new Date().getFullYear() }}, Creado por
                      <a href="https://therealdevs.pro" class="font-weight-bold text-dark" target="_blank">
                        therealdevs.pro
                      </a>.
                      Todos los derechos reservados.
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
// Se usa Input nativo, pero se mantiene ArgonButton
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "@/assets/img/logo.png";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "SignUpView",
  components: {
    // ArgonInput ha sido removido
    ArgonButton,
  },
  data(){
    return{
      logo,
      registrationLoading: false,
      // 🛑 NUEVOS CAMPOS Y ESTADOS
      passwordFieldType: 'password', // Visibilidad Contraseña 1
      confirmPasswordFieldType: 'password', // Visibilidad Contraseña 2
      confirmPassword: null, // Campo de confirmación
      user:{
        username: null,
        password: null,
        email: null,
        document: null,
        full_name: null,
      }
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods:{
    // 🛑 MÉTODO PARA ALTERNAR VISIBILIDAD
    togglePasswordVisibility(field) {
        if (field === 'password') {
            this.passwordFieldType =
                this.passwordFieldType === 'password' ? 'text' : 'password';
        } else if (field === 'confirm') {
            this.confirmPasswordFieldType =
                this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
        }
    },

    async registerUser() {
      this.registrationLoading = true;
      let self = this;

      // 1. Validar campos obligatorios (ya estaban)
      if (!self.user.username || !self.user.password || !self.user.email || !self.user.full_name || !self.user.document || !self.confirmPassword) {
          this.registrationLoading = false;
          Swal.fire('Error', 'Por favor, completa todos los campos requeridos.', 'warning');
          return;
      }

      // 🛑 2. VALIDACIÓN CRUCIAL: Contraseñas Coinciden 🛑
      if (self.user.password !== self.confirmPassword) {
          this.registrationLoading = false;
          Swal.fire('Error', 'Las contraseñas no coinciden. Por favor, revísalas.', 'error');
          return;
      }

      // 3. Preparar los datos para la API
      const registrationData = {
          ...self.user,
          role_id: 2,
          company: 1,
          is_active: 1,
      };

      const apiURL = self.$store.state.apiURL;
      const url = `${apiURL}users`;

      try {
          const result = await axios.post(url, registrationData);
          console.log(result)
          Swal.fire({
              title: '¡Registro Exitoso!',
              text: 'Tu cuenta ha sido creada. Ahora puedes iniciar sesión.',
              icon: 'success',
              confirmButtonColor: '#2dce89'
          }).then(() => {
              self.$router.push({ name: 'Signin'});
          });

      } catch (err) {
          console.error("Fallo de registro:", err.response || err);

          let errorText = 'Ocurrió un error al intentar registrar la cuenta. Intenta más tarde.';
          if (err.response && err.response.data && err.response.data.error) {
              errorText = err.response.data.error;
          }

          Swal.fire({
              title: 'Fallo de Registro',
              text: errorText,
              icon: 'error',
              confirmButtonColor: '#bf4f51'
          });

      } finally {
          this.registrationLoading = false;
      }
    }
  }
};
</script>

<style scoped>
/* Estilos para el input group del ojo */
.password-toggle {
    cursor: pointer;
    background-color: white;
    border-left: none;
    border-color: #dee2e6; /* Color del borde de Bootstrap */
    padding-right: 15px;
}
</style>